export function createQualityFieldService(deps) {
    const {
        PANEL_TYPE,
        ROW_ID_FIELD,
        QUALITY_PANEL_FIELD_MAP,
        DicVal,
        canonicalPanelType,
        normalizeColumnIdUpper,
        getSaveableColumnIdSetByPanelType,
        isKakousijiSavePayloadUiOnlyField
    } = deps;

    // 品質表示 panel type ごとの物理列対応を返します。
    function getQualityPanelFieldMap(panelType) {
        return QUALITY_PANEL_FIELD_MAP[canonicalPanelType(panelType)] || null;
    }

    // 品質表示の invalid 判定列を返します。
    function getQualityInvalidField(panelType) {
        return String(DicVal(getQualityPanelFieldMap(panelType), "invalid", "") ?? "").trim();
    }

    // 品質表示BASEで保存対象になる項目一覧を返します。
    function getQualityBaseFieldIds() {
        const map = getQualityPanelFieldMap(PANEL_TYPE.QUALITY_BASE) || {};
        const excluded = new Set([
            ROW_ID_FIELD,
            "INDEX",
            "GRIP",
            "EXPAND",
            "ROW_KIND",
            String(DicVal(map, "no", "") ?? ""),
            String(DicVal(map, "item", "") ?? ""),
            String(DicVal(map, "group", "") ?? ""),
            String(DicVal(map, "groupFallback", "") ?? ""),
            String(DicVal(map, "color", "") ?? ""),
            String(DicVal(map, "order", "") ?? ""),
            String(DicVal(map, "invalid", "") ?? "")
        ].map((fieldId) => normalizeColumnIdUpper(fieldId)).filter((fieldId) => fieldId !== ""));

        return [...getSaveableColumnIdSetByPanelType(PANEL_TYPE.QUALITY_BASE)]
            .map((fieldId) => String(fieldId ?? "").trim())
            .filter((fieldId) => {
                const cid = normalizeColumnIdUpper(fieldId);
                return cid !== "" && cid.startsWith("SSDQ_") && !excluded.has(cid) && !isKakousijiSavePayloadUiOnlyField(fieldId, PANEL_TYPE.QUALITY_BASE);
            });
    }

    // 指定項目が品質表示BASE項目か判定します。
    function isQualityBaseField(columnId) {
        const target = normalizeColumnIdUpper(columnId);
        if (target === "") return false;
        return getQualityBaseFieldIds().some((fieldId) => normalizeColumnIdUpper(fieldId) === target);
    }

    return {
        getQualityPanelFieldMap,
        getQualityInvalidField,
        getQualityBaseFieldIds,
        isQualityBaseField
    };
}
